import { apiService } from '../../../../services/apiService';

/**
 * Fetches the aggregated Jobseekers Report (intake trend + stage/visa/manager/
 * training/hold breakdowns) from the backend in a single request. All
 * counting happens server-side (COUNT()/GROUP BY), so this stays fast
 * regardless of how many jobseekers exist — never fetch per-record data
 * here for chart/report purposes.
 *
 * @param {Object} params
 * @param {string} [params.granularity] this_week|last_week|this_month|last_month|this_year|last_year|custom
 * @param {string} [params.start_date] required when granularity === 'custom'
 * @param {string} [params.end_date] required when granularity === 'custom'
 * @param {string[]} [params.dimensions] subset of stage|sub_stage|visa|manager|training_status|onboarding_hold
 * @param {string} [params.onboarding_hold] include|exclude|only
 * @param {string} [params.training_status] include|exclude|only
 * @param {Array} [params.filters] advanced filter objects, same shape as the jobseeker list
 */
export const fetchJobseekerReport = (params = {}) => {
    return apiService.postRequest('/admin/jobseeker/report', params);
};
